import styled from "styled-components";
import { slideIn } from "../../shared/GlobalStyles/styles";

export const Container = styled.div`
    position:fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 3001;
    justify-content: center;
    text-align: center;
    align-items: center;
    background-color: ${({ theme }) => theme.backgrounds.gray6};
    animation: ${props => !props?.animation ? 'none' : slideIn } 400ms ease-in-out;
`;


export const WrapperModal = styled.div`
    display: flex;
    width: ${props => props?.width ?? '90%'};
    max-width: ${props => props?.width ?? '100%'};
    height: ${props => props?.height ?? '90%'};
    max-height: ${props => props?.height ?? '100%'};
    text-align: center;
    flex-direction:column;
    background: ${props => props.theme.backgrounds.white};
    border-radius: 8px;
    position: relative;
    border: ${({theme}) => theme.border.very_small};


    @media (max-width:600px){
        width: ${props => props?.width ?? '90%'};
        max-width: ${props => props?.width ?? '100%'};
        height: ${props => props?.height ?? '90%'};
        max-height: ${props => props?.height ?? '100%'};
    }

    @media (max-width:500px){
        width: 100%;
        max-width: 100%;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    padding: 10px 10px 10px;
    gap: 10px;
    width: 100%;
    flex-wrap: wrap;
    border-bottom: ${props => props.theme.border.very_small_gray5};

    h1{
        font-weight: ${props => props.theme.font_weight.large};
        font-size: 24px;
        line-height: 30px;
        color: ${props => props.theme.colors.black}!important ;
    }

`;

export const CloseModal = styled.div`
    position: absolute;
    right:10px;
    top: 5px;
    cursor: pointer;
    font-weight: 500;
    font-size: 24px;
    color: ${({theme}) => theme.colors.black};

`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    /* width: 100%;   
    height: 100dvh; */

    width: ${props => props?.width ?? '100%'};
    max-width: ${props => props?.width ?? '100%'};
    height: ${props => props?.height ?? '100dvh'};
    max-height: ${props => props?.height ?? '100dvh'};
    position: relative;
    overflow-y: auto; 
    padding: ${props => props.theme.paddings.medium};
`;

export const FooterButtons = styled.div`
    position: relative;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 10px 24px;
    gap: ${props => props.theme.gaps.more_less_big};
    width: 100%;
`;
